// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getJobQuoteState } from "@insite/client-framework/Store/Data/JobQuotes/JobQuotesSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import QuoteTotalDisplay from "@store/Library/Components/Toolkit/Quotes/QuoteTotalDisplay";
import React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    jobQuoteState: getJobQuoteState(state, state.pages.rfqJobQuoteDetails?.jobQuoteId),
    showPricing: state.context.showPricing,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface RfqJobQuoteDetailsTotalStyles {}

export const rfqJobQuoteDetailsTotalStyles: RfqJobQuoteDetailsTotalStyles = {};

const styles = rfqJobQuoteDetailsTotalStyles;

const RfqJobQuoteDetailsTotal = ({ jobQuoteState, showPricing }: Props) => {
    const jobQuote = jobQuoteState.value;

    if (!jobQuote || !jobQuote.jobQuoteLineCollection || !showPricing) {
        return null;
    }

    return <QuoteTotalDisplay jobQuote={jobQuote} />;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(RfqJobQuoteDetailsTotal),
    definition: {
        displayName: "Total",
        allowedContexts: ["RfqJobQuoteDetailsPage"],
        group: "RFQ Job Quote Details",
    },
};

export default widgetModule;
